import { version } from "../../Helpers/Utils/Common";

const PersistentFooter = () => {
  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        right: 0,
        padding: "8px 16px",
        zIndex: 10,
        pointerEvents: "none",
      }}
    >
      <span style={{ fontSize: "12px", color: "#6b7280" }}>
        EMR System v{version} - Powered by MYT
      </span>
    </div>
  );
};

export default PersistentFooter;